export default {
  model (resource) {
    return Object.assign({
      imageUrl: null,
      textContent: null
    }, resource)
  },
  rules () {
    return {
      imageUrl: [
        {required: true, message: 'La imagen es requerida'}
      ],
      textContent: [
        {required: true, message: 'El contenido es requerido'}
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/campaigns/campaign-contain-model.js